<template>
  <div class="auth-page-wrap">
    <div class="auth-card pay-card">
      <h1>确认支付</h1>
      <p class="pay-title">{{ payTitle }}</p>
      <div class="pay-amount">¥ {{ price }}</div>
      <button class="btn-submit" @click="pay">立即支付</button>
    </div>
    <div v-if="qrPayVisible" class="qr-pay-mask" @click.self="closeQrPay">
      <div class="qr-pay-dialog">
        <h3>微信扫码支付</h3>
        <p class="qr-tip">请使用微信扫一扫完成支付</p>
        <img v-if="qrPayUrl" :src="qrPayUrl" alt="支付二维码" class="qr-img"/>
        <button type="button" class="btn-ghost" @click="closeQrPay">关闭</button>
      </div>
    </div>
  </div>
</template>

<script>
import { getVideoSeriesInfo, getVipManagerInfo } from '@/utils/http'
import { startWechatPay, buildWechatQrUrl, handleWechatPayError, startWechatPayPoll, stopWechatPayPoll } from '@/utils/wxPay'

export default {
  name: 'WechatPayPage',
  data() {
    return {
      payId: null,
      type: null,
      price: null,
      payTitle: null,
      qrPayVisible: false,
      qrPayUrl: ''
    }
  },
  async mounted() {
    this.payId = this.$route.query.id
    this.vaId = this.$route.query.vaId
    this.type = Number(this.$route.query.type)
    if (this.type === 1) {
      const res = await getVideoSeriesInfo({ id: this.payId })
      if (res.data) {
        this.price = res.data.price
        this.payTitle = '购买单片【' + res.data.title + '】'
      }
    } else if (this.type === 2) {
      const res = await getVipManagerInfo({ id: this.payId })
      if (res.data) {
        this.price = res.data.price
        this.payTitle = '购买会员【' + res.data.title + '】'
      }
    }
  },
  beforeDestroy() {
    stopWechatPayPoll()
  },
  methods: {
    closeQrPay() {
      stopWechatPayPoll()
      this.qrPayVisible = false
    },
    async pay() {
      try {
        const returnUrl = window.location.href
        const result = await startWechatPay({
          title: this.payTitle,
          amount: Math.round(this.price * 100),
          type: this.type,
          id: this.type === 1 ? this.vaId : this.payId,
          returnUrl
        })
        if (result.status === 'success') {
          this.$alert('支付成功', '提示', { confirmButtonText: '确定', center: true })
        } else if (result.status === 'native') {
          this.qrPayUrl = buildWechatQrUrl(result.codeUrl)
          this.qrPayVisible = true
          startWechatPayPoll(result.outTradeNo, {
            onPaid: () => {
              this.closeQrPay()
              this.$alert('支付成功', '提示', { confirmButtonText: '确定', center: true })
            }
          }).catch(() => {})
        }
      } catch (e) {
        handleWechatPayError(e)
      }
    }
  }
}
</script>

<style scoped>
.pay-card {
  text-align: center;
}

.pay-title {
  font-size: 15px;
  color: var(--text-secondary);
  margin-bottom: 16px;
  line-height: 1.6;
}

.pay-amount {
  font-size: 36px;
  font-weight: 700;
  color: var(--tx-accent);
  margin-bottom: 28px;
}

.qr-pay-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.qr-pay-dialog {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  text-align: center;
  max-width: 320px;
}

.qr-tip {
  color: #666;
  margin: 8px 0 16px;
}

.qr-img {
  width: 220px;
  height: 220px;
  display: block;
  margin: 0 auto 16px;
}
</style>
